import TimelineCard from "./timeline-card";
import './timeline.css';
import { useState } from 'react';

const Timeline = ({timelineElements}) => {
    const [activeCard, setActiveCard] = useState(null);

    return (
        <div className="modern-timeline-wrapper">
            <div className="timeline-header">
                <div className="timeline-brand-bar"></div>
                <h3 className="timeline-title">Professional Journey</h3>
                <div className="timeline-brand-bar"></div>
            </div>

            <div className="modern-timeline-container">
                <div className="timeline-line"></div>
                {timelineElements.sort((a,b) => a.id - b.id).map((element, index) => (
                    <TimelineCard
                        key={element.id}
                        title={element.title}
                        text={element.text}
                        date={element.date}
                        images={element.images}
                        index={index}
                        isActive={activeCard === element.id}
                        onHover={() => setActiveCard(element.id)}
                        onLeave={() => setActiveCard(null)}
                        totalItems={timelineElements.length}
                    />
                ))}
            </div>
        </div>
    );
}

export default Timeline;